import styles from "./Navicon.module.css";

const Navicon: React.FC<{ active?: boolean; onClick?: () => void }> = ({
  active,
  onClick,
}) => {
  const lines = 3;

  return (
    <a
      href="#"
      className={`${styles.navicon} ${active ? styles.active : ""}`}
      onClick={(e) => {
        e.preventDefault(); // Prevent default anchor behavior
        if (onClick) onClick(); // Call the onClick handler if provided
      }}
    >
      {Array.from({ length: lines }).map((_, index) => (
        <aside key={index} className={styles.line} />
      ))}
    </a>
  );
};

export default Navicon;
